import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import OpcoesPaginacao from '../comum/OpcoesPaginacao'
import determinarPaginaAtual from '../../actions/usuario/determinarPaginaAtualUsuarios'
import alterarRegistrosPorPagina from '../../actions/usuario/alterarRegistrosPorPaginaUsuarios'

export class PaginacaoUsuarios extends Component {
  render () {
    return <OpcoesPaginacao
      registrosPorPagina={this.props.registrosPorPagina}
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      determinarPaginaAtual={this.props.determinarPaginaAtual}
      alterarRegistrosPorPagina={this.props.alterarRegistrosPorPagina}/>
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    determinarPaginaAtual,
    alterarRegistrosPorPagina
  }, dispatch)
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualUsuario,
    total: state.usuarios.total,
    registrosPorPagina: state.registrosPorPaginaUsuario
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginacaoUsuarios)
